import { FormWithRedux } from '../../FormWithRedux';

export class GPChestPainProbabilityOfMACEGraphForm extends FormWithRedux {

    constructor() {
        super('probabilityOfMACEGraphForm');
    }

    getGraphValue(){
        return this.getValue('probabilityOfMACE');
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    editingValidation() {
        return [];
    }

    detailString() {
        return '';
    }

}


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Forms/GPChestPain-ProbabilityOfMACEGraphForm.js